import Navbar from '../components/Navbar';
import Footer from 'components/Footer';
import { useSelector } from "react-redux";
import MobileNavbar from 'components/MobileNavbar';
import MobileFooter from 'components/MobileFooter';
import HomePage from 'components/Home/HomePage';

function Home() {

  const isMobile = useSelector(state => state.windowSize.isMobile);

  return (
    <>
    {isMobile ? (
      <>
        <MobileNavbar />
        <HomePage />
        <MobileFooter />
      </>
    ) : (
      <>
        <Navbar />
        <HomePage />
        <Footer />
      </>
    )}
    </>
  );
}

export default Home;
